import React from 'react';
import 'react-spring-bottom-sheet/dist/style.css'
import styled from 'styled-components';
import {useToast} from "@chakra-ui/react";
import {useHistory} from "react-router-dom";
import {MessageCircle, Shield, User, UserRoundMinus} from "lucide-react";
import useFeedback from "../../utils/use_feedback";
import {useBlock} from "../../api/user";
import {useLoggedIn} from "../../store";
import {useSheetModal} from "../test/ModalContext";
import Sheet, {MenuItem, MenuItemIcon, MenuItemText} from './sheet';
import ModeratingSheet from "./moderating";
import UserDetailsSheet from "./user_details";
import SignupPromptSheet from "./signup_prompt";

const AboutProfileSheet = styled(({className, username, onClose}) => {

    const { openModal } = useSheetModal();

    const loggedIn = useLoggedIn();
    const {feedbackCh} = useFeedback(true);
    const toast = useToast();

    const block = useBlock(feedbackCh);
    const handleBlockUser = async () => {
        onClose();
        if (!loggedIn) {

            const modalContent = ({ handleCloseModal }) => (
                <Sheet onClose={() => handleCloseModal() } padding={"header"}><SignupPromptSheet onClose={() => handleCloseModal() } /></Sheet>
            );

            openModal(modalContent);

        } else {
            try {
                await block(username);
                toast({
                    title: `Blocked user!`,
                    status: 'success',
                    isClosable: true,
                });
            } catch {
                toast({
                    title: `Failed to block.`,
                    status: 'error',
                    isClosable: true,
                });
            }
        }
    };

    const history = useHistory();
    const handleMessage = () => {

        onClose();

        if (!loggedIn) {

            const modalContent = ({ handleCloseModal }) => (
                <Sheet onClose={() => handleCloseModal() } padding={"header"}><SignupPromptSheet onClose={() => handleCloseModal() } /></Sheet>
            );

            openModal(modalContent);

        } else {
            history.replace(`/send?to=${username}`);
        }

    }

    const handleAbout = () => {

        onClose();

        const modalContent = ({ handleCloseModal }) => (
            <Sheet onClose={() => handleCloseModal() } padding={"header"}><UserDetailsSheet username={username} onClose={() => handleCloseModal() } /></Sheet>
        );

        openModal(modalContent);

    }

    const handleModerating = () => {

        onClose();

        const modalContent = ({ handleCloseModal }) => (
            <Sheet onClose={() => handleCloseModal() } padding={"menu"}><ModeratingSheet username={username} onClose={() => handleCloseModal() } /></Sheet>
        );

        openModal(modalContent);

    }

    return (
        <div className={className}>
            <MenuItem onClick={handleAbout}>
                <MenuItemIcon>
                    <User size={24} />
                </MenuItemIcon>
                <MenuItemText>
                    About
                </MenuItemText>
            </MenuItem>
            {username !== "me" &&
                <>
                    <MenuItem onClick={handleMessage}>
                        <MenuItemIcon>
                            <MessageCircle size={24} />
                        </MenuItemIcon>
                        <MenuItemText>
                            Message
                        </MenuItemText>
                    </MenuItem>
                    <MenuItem onClick={handleBlockUser}>
                        <MenuItemIcon>
                            <UserRoundMinus size={24} />
                        </MenuItemIcon>
                        <MenuItemText>
                            Block
                        </MenuItemText>
                    </MenuItem>
                </>
            }
            <MenuItem onClick={handleModerating}>
                <MenuItemIcon>
                    <Shield size={24} />
                </MenuItemIcon>
                <MenuItemText>
                    Moderating
                </MenuItemText>
            </MenuItem>
        </div>
    );
})``;

export default AboutProfileSheet;
